<script>
import {LIcon, LMap, LMarker, LTileLayer} from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import {getCoordinatesFromAddress} from "@/lib";
import RichText from "@/components/ui/RichText.vue";

export default {
  name: "EventMap",
  props: ["event"],
  components: {
    RichText,
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
  },
  data: () => ({
    coordinates: [],
    mapStyle: {
      height: '330px',
      zIndex: 0,
    },
    mapConfig: {
      zoom: 16,
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    },
    iconUrl: require("../../../public/img/map-marker.png"),
  }),
  async mounted() {
    const { Strasse, Hausnummer, PLZ, Ort} = this.event.Adresse
    const coordinates = await getCoordinatesFromAddress(`${Strasse} ${Hausnummer}, ${PLZ} ${Ort}`);

    if(coordinates) {
      this.coordinates.push(coordinates.lat);
      this.coordinates.push(coordinates.lng);
    }
  },
  computed: {
    columnConfig() {
      if(this.event.HinweisZurAnfahrt?.length > 0) {
        return {
          showHint: true,
          mapWidth: 6
        };
      }

      return {
        showHint: false,
        mapWidth: 12
      }
    }
  }
}
</script>

<template>
  <v-row class="px-5 mt-0 mb-3">
    <v-col cols="12" md="6" v-if="columnConfig.showHint">
      <rich-text :markdown-text="event.HinweisZurAnfahrt" />
    </v-col>
    <v-col cols="12" :md="columnConfig.mapWidth">
      <l-map :style="mapStyle" :zoom="mapConfig.zoom" :center="coordinates" v-if="coordinates.length === 2">
        <l-tile-layer :url="mapConfig.url" :attribution="mapConfig.attribution"></l-tile-layer>
        <l-marker :lat-lng="coordinates">
          <l-icon icon-url="/img/map-marker.png" :icon-size="[46, 52]" :icon-anchor="[23, 52]"></l-icon>
        </l-marker>
      </l-map>
    </v-col>
  </v-row>

</template>

<style scoped>

</style>
